module.exports = __webpack_public_path__ + "static/media/logo_ard-ci.0939002a.svg";